import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";
import { MdArrowBack, MdArrowLeft, MdArrowRight, MdAttachFile, MdClose, MdFileCopy, MdFilePresent, MdForward, MdForward10, MdForwardToInbox, MdReply, MdSend } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { researcherMailConst, web_url } from "../../constant";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";


function TeacherEmailRead({ t, lang }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });

    const [content, setContent] = useState({
        messageId: "",
        threadId: "",
        subject: "",
        other: '',
        type: ''
    });


    const [messagesArray, setmessagesArray] = useState([
        {
            messageId: "",
            sender: "",
            body: "",
            status: "",
            sentAt: "",
            language: "",
            type: "",
            attachments: [],
            otherPerson: "",
            receiver: ''
        }
    ])
    const [indexOfMessageShowingNow, setIndexOfMessageShowingNow] = useState(0)

    const [isReceived, setIsReceived] = useState(false);

    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();

    useEffect(() => {
        if (localStorage.getItem('mailsent')) {
            const mail = JSON.parse(localStorage.getItem('mailsent'));
            setContent(mail)
        } else if (localStorage.getItem('maildraft')) {
            const mail = JSON.parse(localStorage.getItem('maildraft'));
            setContent(mail)
        } else if (localStorage.getItem('mailreceived')) {
            const mail = JSON.parse(localStorage.getItem('mailreceived'));
            setContent(mail)
        }
    }, [])

    useEffect(() => {
        if (messagesArray) {
            if (messagesArray[indexOfMessageShowingNow]?.receiver === logDetails.email) {
                // console.log("abi idiot 1");
                setIsReceived(true)
            } else {
                // console.log("abi idiot 2");
                setIsReceived(false)
            }
        }
    }, [indexOfMessageShowingNow, messagesArray])

    useEffect(() => {

        // console.log('received',isReceived);

    }, [isReceived])

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };


    useEffect(() => {
        setIsLoading(true);
        if (content.threadId) {
            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };
            axios.get(`${web_url}/api/email-threads/${content.threadId}`, configToken).then((response) => {
                // console.log("resnow", response.data);

                const sortedMessages = response.data.messages
                    .sort((a, b) => new Date(a.sentAt) - new Date(b.sentAt))
                    .map((message) => ({
                        ...message,
                        receiver: response.data.participants.find(email => email !== message.sender)
                    }));
                setmessagesArray(sortedMessages);
                setIsLoading(false);


            }).catch((err) => {
                handleClickOpenError('error occured')
                setIsLoading(false);
            })
        }
    }, [content])
    // console.log("this is tha response", messagesArray);
    useEffect(() => {

    }, [messagesArray])

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }], // Header options (H1, H2, and normal text)
            ['bold', 'italic', 'underline'], // Inline styles
            [{ list: 'ordered' }, { list: 'bullet' }], // Ordered and unordered lists
        ],
    };

    // const formats = ["bold", "italic", "underline", "list", "bullet", "size"];

    const navigate = useNavigate();

    const [showLeftArrow, setShowLeftArrow] = useState(false)
    const [showRightArrow, setShowRightArrow] = useState(false)

    useEffect(() => {
        if (messagesArray) {
            if (messagesArray.length === 1) {
                setShowLeftArrow(false);
                setShowRightArrow(false);
                setIndexOfMessageShowingNow(0);
            } else {
                const index = messagesArray.findIndex((message) => message.messageId === content.messageId);
                setIndexOfMessageShowingNow(index);
            }
        }
    }, [messagesArray])

    useEffect(() => {
        if (messagesArray.length === 1) {
            setShowLeftArrow(false);
            setShowRightArrow(false);
            setIndexOfMessageShowingNow(0);
        } else {
            if (indexOfMessageShowingNow === (messagesArray.length) - 1) {
                setShowRightArrow(false);
            } else {
                setShowRightArrow(true);
            }

            if (indexOfMessageShowingNow === 0) {
                setShowLeftArrow(false);
            } else {
                setShowLeftArrow(true);
            }
        }

        // console.log('message', messagesArray[indexOfMessageShowingNow]);

    }, [indexOfMessageShowingNow, messagesArray])

    const handleRightArrow = () => {
        setIndexOfMessageShowingNow(indexOfMessageShowingNow + 1);
    }

    const handleLeftArrow = () => {
        setIndexOfMessageShowingNow(indexOfMessageShowingNow - 1);
    }

    const handleReplyButton = () => {
        const mailRequest = {
            type: 'old',
            threadId: content.threadId,
            subject: content.subject,
            to: isReceived ? content.sender : content.other,
        };
        localStorage.setItem('threadId', JSON.stringify(mailRequest));
        if (isXlOrLarger) {
            navigate('/desktop/teacher/mailbox');
        } else {
            navigate('/mobile/teacher/mailbox/composemail');
        }
    }


    const [reject, setReject] = useState(false);

    const [rejectMessage, setRejectMessage] = useState("");

    const [rejectError, setRejectError] = useState(false)

    const clickReport = () => {
        if (rejectMessage === "") {
            setRejectError(true);
            return;
        }
        // rejectMail();
        replyToAdminMail();

    }

    const [open6, setOpen6] = useState(false)

    const handleClose6 = () => {
        setOpen6(false);
        localStorage.setItem("refresh", `${Date.now()}`);
        navigate('/mobile/teacher/mailbox/inbox')
    }

    const [open7, setOpen7] = useState(false)

    const handleClose7 = () => {
        setOpen7(false);
        localStorage.setItem("refresh", `${Date.now()}`);
        navigate('/mobile/teacher/mailbox/inbox')
    }

    const rejectMail = () => {
        setIsLoading(true);
        let message_id = messagesArray[indexOfMessageShowingNow].messageId;
        let thread_id = content.threadId;
        const reason = {
            reason: rejectMessage
        }
        const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${logDetails2.token}`,
            },
        };
        axios.put(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}/moderate?moderator=${logDetails.email}&action=REJECTED`, reason, config).then((response) => {
            setIsLoading(false);
            setOpen6(true);
        }).catch((err) => {
            setIsLoading(false);
            handleClickOpenError("error occured");
        })


    }

    const replyToAdminMail = () => {
        setIsLoading(true);
        let message_id = messagesArray[indexOfMessageShowingNow].messageId;
        let thread_id = content.threadId;
        const reason = {
            reason: rejectMessage
        }
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        const newMail = {
            newEmail: logDetails.email
        }
        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails.token}`,
            },
        };

        const config2 = {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${logDetails.token}`,
            },
        };

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        const formData = new FormData();

        formData.append("sender", logDetails.email);
        formData.append("body", rejectMessage);
        formData.append("language", "English");
        formData.append("isDraft", "FALSE");
        formData.append("type", "NONE");
        formData.append("translatedBody", "NA");

        axios.put(`${web_url}/api/email-threads/${thread_id}/participants/${researcherMailConst}`, newMail, config).then((resChangeEmail) => {
            axios.patch(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}/type?type=NONE`, {}, configToken).then((resChangeType) => {
                axios.post(`${web_url}/api/email-threads/${thread_id}/add-message`, formData, config2).then((resMsgSend) => {
                    setIsLoading(false);
                    setOpen6(true);
                }).catch((errSendMsg) => {
                    setIsLoading(false);
                    handleClickOpenError("error occured");
                })
            }).catch((errChangeType) => {
                setIsLoading(false);
                handleClickOpenError("error occured");
            })
        }).catch((errChangeEmail) => {
            setIsLoading(false);
            handleClickOpenError("error occured");
        })
        // axios.put(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}/moderate?moderator=${logDetails.email}&action=REJECTED`, reason, config).then((response) => {


        // }).catch((err) => {

        // })

    }


    const forwardMail = () => {
        setIsLoading(true);
        let message_id = messagesArray[indexOfMessageShowingNow].messageId;
        let thread_id = content.threadId;
        const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails2.token}`,
            },
        };

        const moderationData = {
            moderator: logDetails.email,
            action: "APPROVED",
            approvedAttachments: []
        }
        axios.put(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}/moderate?moderator=${logDetails.email}&action=APPROVED`, moderationData, config).then((response) => {
            setIsLoading(false);
            setOpen7(true);
        }).catch((err2) => {
            // console.log('err2 - ',err2);

            setIsLoading(false);
            handleClickOpenError("error occured");
        })

    }

    const handleDownload = async (fileName, fileUrl) => {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };




    return (
        <>
            <div className="xl:bg-[#FFEBA9] xl:rounded-md mb-[200px] xl:mb-[10px] pl-[30px] xl:pl-[20px] xl:ml-[0px] 2xl:pl-[30px] pr-[30px] xl:pr-[20px] 2xl:pr-[30px] xl:mr-[80px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[1px] 2xl:pt-[5px] xl:pb-[20px] 2xl:pb-[30px] 2xl:pt-[0px] xl:mt-[20px] 2xl:mt-[30px]">
                <div className="flex w-full items-center justify-center">
                    <div className="flex items-center mt-[20px] justify-between w-full md:w-[600px]">
                        <div className="flex items-center justify-between w-full ">
                            <div className="flex items-center">
                                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                    navigate('/mobile/teacher/mailbox/inbox')
                                }} />
                                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                    navigate('/mobile/teacher/mailbox/inbox')
                                }} />
                                <p className={`font-bold ml-[10px] ${lang === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]")}`}>{t('t234')}</p>
                            </div>
                            <div className="flex items-center">
                                {
                                    content.type !== "ADMIN" &&
                                    <>
                                        <button className={`px-[20px] py-[8px] gap-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} rounded-md  border border-1  border-[#0E141F] font-[600]`}
                                            onClick={handleReplyButton}>{t('t260')}</button>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center w-full">
                    <div className="flex items-center w-full md:w-[600px] justify-end">
                        <div className="flex items-center mt-[10px]">
                            {
                                showLeftArrow &&
                                <>
                                    <MdArrowLeft onClick={handleLeftArrow} size={40} className="md:hidden" />
                                    <MdArrowLeft onClick={handleLeftArrow} size={50} className="hidden md:block" />
                                </>
                            }

                            {
                                showRightArrow &&
                                <>
                                    <MdArrowRight onClick={handleRightArrow} size={40} className="md:hidden" />
                                    <MdArrowRight onClick={handleRightArrow} size={50} className="hidden md:block" />
                                </>
                            }
                        </div>
                    </div>
                </div>


                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    {isReceived &&
                                        <p className={`text-gray-500 text-[15px]`}>{t('t235')}:</p>
                                    }
                                    {!isReceived &&
                                        <p className={`text-gray-500 text-[15px]`}>{t('t220')}:</p>
                                    }
                                    {messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow]?.sender &&
                                        isReceived && <input value={messagesArray[indexOfMessageShowingNow].sender} readOnly type="text" name="receptionist" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                        />
                                    }
                                    {
                                        messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] &&
                                        !isReceived && (
                                            <input
                                                value={messagesArray[indexOfMessageShowingNow].receiver || ""}
                                                readOnly
                                                type="text"
                                                name="receptionist"
                                                className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                            />
                                        )
                                    }
                                </div>
                            </div>

                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                                    <input readOnly value={(content.subject.trim()) ? content.subject.trim() : "(No subject)"} type="text" name="subject" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${content.subject.trim() ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t224')}
                                    />
                                </div>
                            </div>

                            <div className="mt-[20px] md:pl-[100px] lg:pl-[200px] xl:pl-[10px] flex flex-col gap-[5px] mb-[10px]">
                                {
                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.attachments &&
                                    <>
                                        {(messagesArray[indexOfMessageShowingNow].attachments).map((file, index) => (
                                            <div key={index} className="flex items-center justify-between">
                                                <div className="flex items-center cursor-pointer" onClick={() => handleDownload(file.fileName, file.fileUrl)}>
                                                    <MdFilePresent />
                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                }
                            </div>

                            <div className="md:flex md:justify-center md:items-center">
                                {
                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.body &&
                                    <div className="justify-center items-center w-full md:w-[600px]">
                                        <ReactQuill
                                            modules={{ toolbar: false }}
                                            value={messagesArray[indexOfMessageShowingNow].body}
                                            readOnly
                                            theme="snow"
                                            placeholder={t('t225')}
                                            className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                                    </div>
                                }
                            </div>

                            {
                                content?.moderationRecord?.reason &&
                                <div className="md:flex md:justify-center md:items-center">
                                    <div className="items-center mt-[20px] flex md:w-[600px] md:justify-center">
                                        <textarea className={` rounded-md w-full bg-[#F1F6FB] text-[15px] text-[#1F2937] shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px] focus:border-none focus:outline-none py-[5px] px-[20px]`}
                                            rows={7} cols={40}
                                            placeholder="Reason for rejection"
                                            readOnly
                                            value={`Rejected reason : \n${JSON.parse(content?.moderationRecord?.reason || '{}')?.reason || ''}`}
                                        />
                                    </div>
                                </div>
                            }

                            {
                                content.type === 'ADMIN' && content.status === "PENDING" &&
                                <div className="flex justify-center items-center gap-[20px]">
                                    <button onClick={() => {
                                        setReject(true)
                                    }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">{t('t260')}</button>

                                    <button onClick={() => {
                                        forwardMail();
                                    }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">{t('t351')}</button>

                                </div>
                            }

                            {
                                content.type === 'ADMIN' && content.status === "REJECTED" &&
                                <div className="flex justify-center items-center">
                                    <button onClick={() => {
                                        forwardMail();
                                    }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Approve and forward</button>

                                </div>
                            }

                            {
                                reject &&
                                <div className="md:flex md:justify-center md:items-center">
                                    <div className="items-center mt-[20px] flex md:w-[600px] md:justify-center">
                                        <textarea className={` rounded-md w-full bg-[#F1F6FB] text-[15px] ${rejectMessage === "" ? 'text-gray-400' : 'text-[#1F2937]'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px] focus:border-none focus:outline-none py-[5px] px-[20px]`}
                                            rows={7} cols={40}
                                            placeholder={t('t426')}
                                            onChange={(e) => (
                                                setRejectMessage(e.target.value)
                                            )}
                                        />
                                    </div>
                                </div>
                            }

                            {(rejectError) &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px] md:mx-[70px] lg:mx-[180px]'>{t('t426')}</p>
                            }
                            {
                                reject &&
                                <div className="flex justify-center gap-[20px] ml-[20px] mr-[20px] md:mx-[150px] lg:mx-[250px] xl:mx-[400px] 2xl:mx-[600px] mt-[20px] md:mt-[20px] xl:mt-[60px] 2xl:mt-[150px]">
                                    <button onClick={clickReport} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[400px] hover:bg-opacity-80 bg-[#F2290E] bg-opacity-20">{t('t427')}</button>
                                </div>
                            }
                        </>
                }


            </div >

            <Dialog
                open={open6}
                onClose={handleClose6}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t275')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose6}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open7}
                onClose={handleClose7}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t279')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose7}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}

export default TeacherEmailRead;
